import React from "react";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/membershipBreakdownSaga";

const GroupBy = () => {
  const dispatch = useDispatch();

  const selectedGroupBy = useSelector((state) => state.membershipBreakdown.selectedFilters.groupBy);
  const groupByOptions = useSelector((state) => state.membershipBreakdown.filters.groupBy);

  return (
    <MultiSelectDropdown
      options={groupByOptions}
      selectedFilters={selectedGroupBy}
      includeFilter={false}
      numberDisplayed={1}
      onSelectChange={(data) => dispatch(actionCreators.updateGroupBy(data))}
    />
  );
};

export default GroupBy;
